import { Button, Heading, Text } from "@instacover/ui"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { MarkIcon } from "../../../../components/icons/MarkIcon"
import { MarkType } from "../../../../components/icons/MarkIcon.utils"
import { BaseLayout } from "../../../../components/layouts/BaseLayout"
import { IconRefresh } from "../../../../images/xd/icons/IconRefresh"
import { TransText } from "../../../../utils/TransText"

export const Route = createFileRoute("/$sessionId/_session/__debug/error")({
  validateSearch: z.object({
    title: z.string().optional(),
    text: z.string().optional(),
  }),
  component: DebugErrorScreen,
})

/**
 * Debug-only screen for capturing error screenshots
 * Usage: /debug/error?title=guide.blurry.title&text=guide.blurry.text
 */
function DebugErrorScreen() {
  const { title: searchTitle, text: searchText } = Route.useSearch()

  const title = searchTitle || "Debug Error Screen"
  const text = searchText || "This is a debug error screen for screenshots"
  const mockImageUrl =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect fill='%23ccc' width='400' height='300'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23666' font-family='Arial' font-size='20'%3EMock Image%3C/text%3E%3C/svg%3E"

  return (
    <BaseLayout>
      <div className="h-vh-header flex flex-col items-center justify-between">
        <div className="h-6 w-6 shrink-0" />

        <div className="flex flex-col items-center justify-start">
          <MarkIcon mark={MarkType.Cross} />

          <div className="h-6 w-6 shrink-0" />

          <Heading as="h2" variant="h1" className="text-ic-primary text-center">
            <TransText>{title}</TransText>
          </Heading>

          <div className="h-4 w-4 shrink-0" />

          <Text as="p" className="text-center">
            <TransText>{text}</TransText>
          </Text>

          <div className="h-6 w-6 shrink-0" />

          {/* Mock image preview */}
          <img
            src={mockImageUrl}
            alt="Mock error preview"
            className="max-h-50 max-w-full rounded-lg border-2 border-[#ddd]"
          />
        </div>

        <div className="flex flex-col items-center justify-between">
          <div className="flex items-center justify-center gap-4">
            <Button variant="secondary" shape="circle" onClick={() => window.location.reload()} className="w-[120px]">
              <IconRefresh className="block w-8" />
            </Button>

            <Button type="button">Použít fotku</Button>
          </div>

          <div className="h-6 w-6 shrink-0 sm:h-10 sm:w-10" />
        </div>
      </div>
    </BaseLayout>
  )
}
